import React from "react";
import { Helmet } from "react-helmet";
import MainImage from "../../assets/MainImage.jpg";
import Footer from "../../components/Footer";
import SecondImage from "../../assets/AboutImage4.jpg";
import NavLite from "../../components/NavLite";
import PastWord from "../../components/PastWord";
import SmallTestimony from "../../components/SmallTestimony";

function Austin() {
  return (
    <section>
      <Helmet>
        <title>High-End Web Design & SEO for Women Entrepreneurs in Austin | Her Growth Co.</title>
        <meta
          name="description"
          content="Empowering Austin’s women-led brands with premium web design and expert SEO. Build a stunning, high-converting online presence with Her Growth Co."
        />
        <meta
          name="keywords"
          content="austin web design for women entrepreneurs, austin seo for female founders, website design for women-led businesses austin, custom websites for austin consultants, high-end website design austin, seo expert for women austin, premium branding austin women, austin digital authority launchpad, conversion-focused web design austin, web strategy for coaches austin, female entrepreneur seo services austin, austin cro expert services, all-in-one solution for experts, content marketing for women-led startups austin, seo for consultants in austin, website design agency austin tx, high-ticket client attraction austin, bespoke web design austin tx, online visibility for women founders, premium digital services austin, seo agency for women-owned business austin, women in business marketing austin, personal brand websites austin tx, social media + web strategy austin, website design for thought leaders austin, conversion optimization austin, cro services texas, website a/b testing texas, advanced cro agency, landing page optimization austin, heatmap analysis websites, austin lead conversion strategy, high-converting website audits, digital behavior analysis, improve website conversions austin, website optimization for sales, cro for female entrepreneurs, sales funnel optimization austin, austin conversion rate experts, ux testing for conversions, cro for personal brands texas, conversion-optimized websites, texas lead capture solutions, premium cro consultants austin, website user experience testing, conversion tracking for websites, web strategy for high-ticket leads, roi-focused website optimization, data-driven cro services, website behavior analytics austin"
        />
      </Helmet>

      {/* Hero Section */}
      <div
        className="relative h-auto bg-cover bg-center"
        style={{
          clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
          backgroundImage: `url(${MainImage})`,
          padding: "20px",
          width: "100%",
        }}
      >
        <NavLite />
        <div className="p-10">
          <h2 className="text-3xl font-bold uppercase text-black mb-4 text-center">
            <span className="bg-[#CFF098] italic">
              Austin Web Design & SEO for Women Entrepreneurs
            </span>
          </h2>
        </div>
      </div>

      {/* CTA Section */}
      <div className="mx-auto w-full max-w-7xl px-5 py-6 md:px-10 md:py-10 flex flex-col items-center text-center">
        <p className="text-gray-200 mb-4 text-2xl max-w-2xl">
           Based in Austin? We design websites and deliver SEO strategies that
          help women entrepreneurs stand out and grow their brands online.
        </p>
        <a href="https://cal.com/woaomwebdesign/15min">
          <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black">
            BOOK A FREE STRATEGY CALL →
          </button>
        </a>
      </div>

{/* Our Process */}
<div className="mx-auto w-full max-w-7xl flex flex-col items-center text-center mt-20">
  <h2 className="text-3xl font-medium md:text-4xl text-white uppercase">
    Our Process
  </h2>
</div>

{/* Centered Paragraph below heading */}
<p className="mx-auto mt-4 max-w-3xl text-sm text-gray-200 sm:text-base md:mb-12 lg:mb-16 text-center">
  We partner with Austin’s women entrepreneurs to create stunning, search-optimized websites—from first concept to final launch.
</p>

<div className="flex flex-col md:flex-row items-stretch gap-8 md:gap-12">
  {/* Text Section */}
  <div className="flex flex-col justify-center w-full md:w-1/2">
    {[
      {
        step: 1,
        title: "Discovery Call",
        desc: "We dive into your goals, your audience, and your unique brand vision to build a strong foundation.",
      },
      {
        step: 2,
        title: "Design & Build",
        desc: "We create a premium, responsive site that speaks to your ideal clients—and converts.",
      },
      {
        step: 3,
        title: "SEO & Strategy",
        desc: "We implement local SEO and keyword strategies to get your business found in Austin and beyond.",
      },
      {
        step: 4,
        title: "Launch & Ongoing Growth",
        desc: "After launch, we support you with ongoing SEO and strategic content to scale your impact.",
      },
    ].map(({ step, title, desc }) => (
      <div key={step} className="mb-8 flex max-w-lg justify-center gap-4 px-6 py-5 text-black">
        <div className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-gray-100">
          <p className="text-sm font-bold sm:text-base">{step}</p>
        </div>
        <div className="ml-4 flex flex-col gap-2">
          <h5 className="text-xl font-medium uppercase text-white">{title}</h5>
          <p className="text-sm text-gray-200">{desc}</p>
        </div>
      </div>
    ))}
  </div>

  {/* Image Section */}
  <div className="w-full md:w-1/2 flex items-stretch">
    <img
      alt="Website Design for Women Entrepreneurs Austin"
      src={MainImage}
      className="w-full object-cover"
    />
  </div>
</div>






      {/* Past Work & Testimonials */}
      <PastWord />
      <SmallTestimony />

      {/* About Us Section */}
      <div className="mx-auto w-full">
        <div className="grid gap-6 sm:gap-6 md:grid-cols-2">
          <div className="flex flex-col items-start gap-2 md:py-24 md:px-24 max-w-[600px] p-4">
            <div className="flex items-center rounded-md py-1">
              <p className="text-sm uppercase mb-12">ABOUT US</p>
            </div>
            <h4 className="mb-6 text-2xl font-semibold md:text-3xl md:mb-8 uppercase">
              Empowering{" "}
              <span className="italic text-black bg-[#CFF098]">
                Austin Women Entrepreneurs
              </span>{" "}
              to Build an{" "}
              <span className="italic text-black bg-[#CFF098]">
                Unshakable Online Presence
              </span>
            </h4>
            <p className="text-sm text-white sm:text-xl">
              We specialize in high-end website design and strategic SEO for Austin’s female-led brands. Whether you’re a coach, consultant, or creative, we help you show up like the expert you are—online and in search.
              <br />
              <br />
              With deep local knowledge and a passion for women-owned business success, we bring clarity, conversion, and visibility to every project.
            </p>
            <p className="mt-6 mb-6 text-xl italic uppercase">
              Ready to grow your brand with confidence?{" "}
              <span className="italic">We’re with you every step.</span>
            </p>

            <div className="flex flex-col gap-4 font-regular sm:flex-row">
              <a
                href="/about"
                className="flex rounded-full items-center gap-4 bg-[#CFF098] px-8 py-2 text-black hover:opacity-60 text-sm"
              >
                <p>LEARN MORE ABOUT US →</p>
              </a>
            </div>
          </div>

          <div className="relative w-full h-[]">
            <img
              src={SecondImage}
              alt="Austin women entrepreneur using laptop"
              className="absolute top-0 right-0 w-auto h-full object-cover"
            />
          </div>
        </div>
      </div>

      <Footer />
    </section>
  );
}

export default Austin;
